import React from "react";

import Background from "./background/Background";
import Classic from "./classic/Classic";
import Notification from "./notification/Notification";
import Image from "./image/Image";
import { DESIGN_STYLES } from "../../../../optics/components/drawers/settings/features/announcements/defaults";

const designComponents = {
  [DESIGN_STYLES.CLASSIC]: Classic,
  [DESIGN_STYLES.BACKGROUND]: Background,
  [DESIGN_STYLES.NOTIFICATION]: Notification,
  [DESIGN_STYLES.IMAGE]: Image,
};

function Design({
  config,
  data,
  isEditable = false,
  viewMode = "view",
  isTemplate = false,
}) {
  const DesignComponent = designComponents[config?.designStyle];

  return (
    <DesignComponent
      data={data}
      config={config}
      isEditable={isEditable}
      viewMode={viewMode}
      isTemplate={isTemplate}
    />
  );
}

export default Design;
